import React from 'react'
import uSwitch2021 from '../../static/images/uswitchBestValue2021.svg'
import { heroContent } from './DataRolloverHero.strings'

import { HeroWrapper, AwardImage } from './DataRolloverHero.styles'

const DataRolloverHero = () => (
  <HeroWrapper>
    {heroContent.title}

    <AwardImage
      data-testid="uswitch-2021"
      src={uSwitch2021}
      alt="uSwitch Award - Best PAYG Network Winner 2021 "
    />
  </HeroWrapper>
)

export default DataRolloverHero
